import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section style={{ textAlign: 'center', paddingTop: '3rem' }}>
      <h1>404</h1>
      <p style={{ marginTop: '1rem', color: 'var(--color-text-muted)' }}>
        La página que buscas no existe.
      </p>
      <Link
        to="/"
        style={{
          display: 'inline-block',
          marginTop: '1.5rem',
          padding: '0.625rem 1.25rem',
          backgroundColor: 'var(--color-accent)',
          color: '#fff',
          borderRadius: 'var(--radius-md)',
          fontWeight: 600,
          transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
          boxShadow: '0 0 20px rgba(124, 58, 237, 0.4)',
        }}
      >
        Volver al inicio
      </Link>
    </section>
  );
}
